const isPro = Object.is(process.env.NODE_ENV, 'production')

console.log(isPro);

module.exports = {
  baseUrl: isPro ? 'https://app.whistle3.com' : 'https://app.whistle3.com'
  // baseUrl: isPro ? 'https://api.xn--6orz56b.com' : 'https://api.xn--6orz56b.com'
	// baseUrl: isPro ? 'http://120.55.42.234:9999' : 'http://120.55.42.234:9999'
}
